// extracted by mini-css-extract-plugin
module.exports = {"c1jod995":"c1jod995"};